/* -------------------------------------------------------------------------- */
/*                               Schema JobsBacklog                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const job = new schema.Entity('jobs', {}, { idAttribute: 'jobId' });
export const jobs = new schema.Array(job);
